import { Component } from '@angular/core';
import { Error } from 'src/app/shared/components/error/error.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pse-error',
  templateUrl: './pse-error.component.html',
  styleUrls: ['./pse-error.component.scss']
})
export class PseErrorComponent {
  assetsUrl = environment.assetsUrl;
  public config: Error = {
    route: this.assetsUrl + '/images/cdt/icons/close-icon.svg',
    image: 'close-icon',
    title: 'Lo sentimos, la transacción ha fallado',
    content:
      'Intenta nuevamente transferir tu plata antes de 48 horas a través de avvillas.com.co. En la sección ahorro e inversión, selecciona CDT.',
    link: {
      url: 'https://www.avvillas.com.co/',
      text: '¿Dónde encontrarnos?'
    }
  };
}
